import * as e from "ramda";
const g = (r, n = "****", t = 5) => {
  if (e.isNil(r) || e.isEmpty(r))
    return "";
  const s = e.slice(0, t, r), c = e.slice(r.length - t, r.length, r);
  return `${s}${n}${c}`;
}, u = (r) => r.toLocaleString(), o = (r) => /^-{0,1}\d*\.{0,1}\d+$/.test(r), i = (r) => r === "true" || r === "false", l = (r) => {
  if (!e.is(Array, r) && !e.is(Object, r)) {
    if (e.is(String, r)) {
      if (o(r))
        return Number(r);
      if (i(r))
        return !!r;
    }
    return r;
  }
  return e.map((t) => l(t), r);
}, m = (r) => e.is(String, r) || e.is(Number, r) ? String(r) : e.is(Object, r) || e.is(Array, r) ? e.map((n) => m(n), r) : null, b = (r, n = "") => n + BigInt(r).toString(16), S = (r, n) => {
  let t = String(r || 0);
  for (; t.length < (n || 2); )
    t = "0" + t;
  return t;
};
export {
  o as checkIsNumber,
  u as commaNumber,
  b as decToHex,
  l as makeTypeObject,
  g as maskString,
  S as padNumber,
  m as recursiveToString
};
//# sourceMappingURL=string.js.map
